import { Area } from '@src/main/modules/common/area/domain/Area';
import { AreaDashboard } from '@src/main/modules/common/area/domain/AreaDashboard';

export const findAreaBasedOnSubsubareaId = (subsubareaId: string, areas: Area[]): AreaDashboard => {
  const areaFound = areas.find((area) =>
    area.subareas.some((subarea) =>
      subarea.subsubareas.some((subsubarea) => subsubarea.id === subsubareaId),
    ),
  );
  const subareaFound = areaFound?.subareas.find((subarea) =>
    subarea.subsubareas.some((subsubarea) => subsubarea.id === subsubareaId),
  );
  const subsubareaFound = subareaFound?.subsubareas.find(
    (subsubarea) => subsubarea.id === subsubareaId,
  );

  return {
    id: areaFound?.id || '',
    name: areaFound?.name || '',
    subareaId: subareaFound?.id || '',
    subareaName: subareaFound?.name || '',
    subsubareaName: subsubareaFound?.name || '',
    subsubareaId: subsubareaFound?.id || '',
  };
};
